<script>
    import MainTitle from "../atoms/MainTitle.svelte";
    import ContactForm from "../molecules/ContactForm.svelte";
    import { SendDataToPhp } from '../service';
    import { getPhpFolderPath } from "../query";

    let valueTextInput;
    let valueTextArea;
    let nameValue;
    let email;

    function SendMail(){
        SendDataToPhp(getPhpFolderPath()+"sendMail.php", "email="+email+"&sujet="+valueTextInput+"&mess="+valueTextArea+"&nom="+nameValue, "contact")
    }
</script>

<MainTitle title="Contact" />

<ContactForm onClick={SendMail} bind:valueTextInput={valueTextInput} bind:valueTextArea={valueTextArea} bind:nameValue={nameValue} bind:email={email} />